export default __webpack_public_path__ + "static/Entenda0110-b78bbf8da4a7a2c0628a64973edf3432.jpg";